export default [
  {
    name: 'loginOff',
    path: '/loginOff/loginOffSuccess',
    meta: { title: '注销成功', whiteList: true },
    component: () =>
      import(
        /* webpackChunkName: "loginOff" */ '../../pages/loginOff/loginOffSuccess'
      )
  }
]
